import IPFile from './IPFile'

export default IPFile
